module.exports = __webpack_public_path__ + "img/login-l.6ef9d260.png";